module.exports = __webpack_public_path__ + "static/media/18ECA47.340c2518.jpg";